import { NotFoundError } from '@cian/peperrors/shared';
import { TGetPikJkResponse } from '../../../repositories/monolith-python/v1/get-pik-jk';

export const assertNotFoundError = (response: TGetPikJkResponse): void => {
  if (response.statusCode === 200) {
    return;
  }

  throw new NotFoundError({
    domain: 'src/node/services/newbuilding/service#assertNotFoundError()',
    message: 'Empty newbuilding data',
  });
};
